import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConsolidateShipmentService } from 'src/app/core/services/consolidate-shipments.service';
import {
    buildGroupedStatusCountsFromRows,
    IStatusCountItem,
} from 'src/app/shared/helpers/consolidate-shipment-status-groups.util';
import { ConsolidateShipmentStatusStatsDialogComponent } from './consolidate-shipment-status-stats-dialog.component';

@Component({
    selector: 'eci-consolidate-shipment-status-counts',
    templateUrl: './consolidate-shipment-status-counts.component.html',
    styleUrls: ['./consolidate-shipment-status-counts.component.scss']
})
export class ConsolidateShipmentStatusCountsComponent implements OnChanges {

    @Input() consolId: number | null | undefined;

    loading = false;
    statusCounts: IStatusCountItem[] = [];

    constructor(
        private dialog: MatDialog,
        private consolShipmentSvc: ConsolidateShipmentService,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['consolId']) {
            this.loadStatusCounts();
        }
    }

    openStatusStats(): void {
        if (this.loading || !this.statusCounts.length) {
            return;
        }

        this.dialog.open(ConsolidateShipmentStatusStatsDialogComponent, {
            width: '360px',
            autoFocus: false,
            panelClass: 'status-stats-dialog',
            data: { statusCounts: this.statusCounts },
        });
    }

    private loadStatusCounts(): void {
        if (!this.consolId) {
            this.loading = false;
            this.statusCounts = [];
            return;
        }

        this.loading = true;
        this.statusCounts = [];
        this.consolShipmentSvc.getStatusCounts(this.consolId).subscribe({
            next: (rows) => {
                this.statusCounts = buildGroupedStatusCountsFromRows(rows);
                this.loading = false;
            },
            error: () => {
                this.statusCounts = [];
                this.loading = false;
            },
        });
    }
}
